module.exports = __webpack_public_path__ + "static/media/lequipe.0a8a1df2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/lequipe.svg
// module id = 1461
// module chunks = 0